import React, { useState } from "react";
import { ContainerWrapper, CardPlan, Vault, TextPlan } from "./styles";
import { useTheme } from "../Theme/ThemeProvider.js";
import { HeroButton } from "../../components/AuthAsAService/styles";
import QrCode from "../../components/QrCode";

export default function PlanCard(props) {
  const { isDarkMode } = useTheme();
  const { title, description, priceMonth, priceAnnual, buttonText } = props;
  const [showQrModal, setShowQrModal] = useState(false);

  const toggleQrModal = () => setShowQrModal((prev) => !prev);

  return (
    <ContainerWrapper>
      <CardPlan>
        <div className="LogoVault">
          <img
            src={
              isDarkMode
                ? "/assets/dark/primatio-plan-dark.png"
                : "/assets/light/primatio-plan-light.png"
            }
            alt="Vault logo"
          />
          <Vault>VAULT</Vault>
        </div>
      </CardPlan>
      <TextPlan>
        <div className="TitlePlan">{title}</div>
        <div className="DescriptionPlan">{description}</div>
        <div className="PricePlan">
          <div>{priceAnnual}</div>
          <div>{priceMonth}</div>
        </div>
      </TextPlan>
      <HeroButton onClick={toggleQrModal}>{buttonText}</HeroButton>
      {showQrModal && <QrCode onClose={toggleQrModal} />}
    </ContainerWrapper>
  );
}
